import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.some.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "home"
  }, [_c('Header'), _c('div', {
    staticClass: "content mincont"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('router-link', {
    attrs: {
      "tag": "span",
      "to": "/"
    }
  }, [_vm._v("首页")]), _c('b', [_vm._v("/")]), _c('em', [_vm._v("优惠券商品")])], 1), _c('div', [_c('div', {
    staticClass: "first-wrap"
  }, [_c('em', {
    staticClass: "classify"
  }, [_vm._v("分类：")]), _c('span', {
    class: {
      active: _vm.firstActive === ''
    },
    on: {
      "click": _vm.handleAll
    }
  }, [_vm._v("全部")]), _vm._l(_vm.classifyList, function (item, index) {
    return _c('span', {
      key: index,
      class: {
        active: _vm.firstActive === item.id
      },
      on: {
        "click": function click($event) {
          return _vm.setSecond(item.id, index);
        }
      }
    }, [_vm._v(_vm._s(item.type_name))]);
  })], 2), _vm.firstActive !== '' && _vm.firstIndex !== '' ? _c('div', {
    staticClass: "second-wrap"
  }, _vm._l(_vm.classifyList[this.firstIndex].pid, function (sub, idx) {
    return _c('span', {
      key: idx,
      class: {
        active: _vm.secondActive.filter(function (e) {
          return e === sub.id;
        }).length > 0
      },
      on: {
        "click": function click($event) {
          return _vm.getClassify(sub);
        }
      }
    }, [_vm._v(_vm._s(sub.typeName))]);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "third-wrap"
  }, [_c('span', {
    class: {
      active: _vm.thirdActive === 1
    },
    on: {
      "click": function click($event) {
        return _vm.setThird(1);
      }
    }
  }, [_vm._v("综合")]), _c('span', {
    staticClass: "price-sort",
    class: {
      active: _vm.thirdActive === 2
    },
    on: {
      "click": function click($event) {
        return _vm.setThird(2);
      }
    }
  }, [_vm._v(" 价格 "), _c('i', {
    staticClass: "el-icon-caret-top"
  }), _c('i', {
    staticClass: "el-icon-caret-bottom"
  })])]), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "list",
    attrs: {
      "element-loading-background": "transparent"
    }
  }, [_vm.couponList.length === 0 ? _c('div', {
    staticClass: "norecord"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/no_record.png")
    }
  }), _c('span', [_vm._v("暂无数据")])]) : _vm._e(), _c('ul', _vm._l(_vm.couponList, function (list, key) {
    return _c('li', {
      key: key,
      staticClass: "list-item",
      on: {
        "click": function click($event) {
          return _vm.goDetails(list.product.id);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": list.imagePath.sourceUrl
      }
    }), _c('div', {
      staticClass: "item-details"
    }, [_c('em', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(list.product.productName))]), _c('p', [_vm._v(_vm._s(list.product.productShortDesc))]), list.product.realDiscountStatus ? _c('Price', {
      attrs: {
        "price": String(list.product.realDiscountPrice)
      }
    }) : _c('Price', {
      attrs: {
        "price": list.product.lowestPrice.split(',')[0]
      }
    }), list.product.realDiscountStatus ? _c('div', {
      staticStyle: {
        "color": "red",
        "margin-left": "10px",
        "margin-bottom": "2px"
      }
    }, [_vm._v("到手价")]) : _vm._e(), _c('div', {
      staticClass: "join-wrap"
    }, [_vm._m(0, true), _c('span', {
      staticClass: "add-cart",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.getNaturePrice(list.product.id, key);
        }
      }
    }, [_c('i', {
      staticClass: "iconfont iconjiarugouwuche"
    }), _c('span', [_vm._v("加入购物车")])])])], 1)]);
  }), 0), _vm.totalnumber > 10 ? _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pageNo,
      "page-sizes": [10, 20, 50],
      "page-size": 10,
      "total": _vm.totalnumber,
      "layout": "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "update:currentPage": function updateCurrentPage($event) {
        _vm.pageNo = $event;
      },
      "update:current-page": function updateCurrentPage($event) {
        _vm.pageNo = $event;
      },
      "size-change": function sizeChange($event) {
        return _vm.handleSizeChange($event);
      },
      "current-change": function currentChange($event) {
        return _vm.handleCurrentChange($event);
      }
    }
  })], 1) : _vm._e()])])]), _c('BackTop'), _c('div', {
    staticClass: "gocard"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm.couponList.length !== 0 ? _c('span', [_vm._v("限时优惠：满" + _vm._s(_vm.couponList[0].fullReduce) + "元减" + _vm._s(_vm.couponList[0].reduceMoney) + "元")]) : _vm._e(), _c('span', {
    staticClass: "cardbtn",
    on: {
      "click": _vm.goCard
    }
  }, [_vm._v("去购物车")])])]), _c('Footer'), _c('el-dialog', {
    attrs: {
      "title": "版本",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false,
      "width": "800px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "nature"
  }, [_vm._l(_vm.naturelist, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "size"
    }, [_c('h4', [_vm._v(_vm._s(item.name))]), _c('ul', _vm._l(item.data, function (value) {
      return _c('li', {
        key: value.id,
        class: {
          active: _vm.selectArr.some(function (ele) {
            return ele.id === value.id;
          }),
          disabled: _vm.checkDisabled(value.id, index)
        },
        on: {
          "click": function click($event) {
            return _vm.selectNature(value, index);
          }
        }
      }, [_vm._v(" " + _vm._s(value.natureValue) + " ")]);
    }), 0)]);
  }), _c('div', {
    staticClass: "number"
  }, [_vm.couponList.length !== 0 ? _c('el-input-number', {
    attrs: {
      "min": 1,
      "step": 1,
      "max": 99999,
      "label": "描述文字",
      "step-strictly": ""
    },
    model: {
      value: _vm.couponList[_vm.couponIndex].val,
      callback: function callback($$v) {
        _vm.$set(_vm.couponList[_vm.couponIndex], "val", $$v);
      },
      expression: "couponList[couponIndex].val"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "dialogfooter"
  }, [_c('span', {
    on: {
      "click": function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取消")]), _c('span', {
    on: {
      "click": function click($event) {
        return _vm.addCart(_vm.couponList[_vm.couponIndex].productPriceId.id, _vm.couponList[_vm.couponIndex].val);
      }
    }
  }, [_vm._v("确定")])])], 2)])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', {
    staticClass: "sale"
  }, [_c('i', {
    staticClass: "iconfont iconhot"
  })]);
}];
export { render, staticRenderFns };